import { useEffect, useState } from "react";
import { CollapsiblePanel } from "./collapsiblePanel";
import { Dropdown } from "../base/dropdown/dropdown";
import { IShapeFile } from "../../../components/earthtwin/models";
import { FileUploader } from "./fileUploader";
import { useNavigate } from "react-router-dom";

interface IFilesListProps {
  onFileUpload: (file: File) => void;
  onFileSelect: (file: IShapeFile) => void;
  shapeFiles: IShapeFile[];
  isUploading?: boolean;
}

export const FilesList = (props: IFilesListProps) => {
  const navigate = useNavigate();

  const [shapeFiles, setShapeFiles] = useState<IShapeFile[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isFileSelected, setIsFileSelected] = useState(false);
  const [selectedFile, setSelectedFile] = useState<IShapeFile | null>(null);

  useEffect(() => {
    setShapeFiles(props.shapeFiles);
  }, [props.shapeFiles]);

  useEffect(() => {
    if (shapeFiles.length > 0 || shapeFiles.length === 0) {
      setShapeFiles(shapeFiles);
      setIsLoading(false);
    }
  }, [shapeFiles]);

  const onFileSelect = (value: string) => {
    const selectedFile = shapeFiles.find((file) => file.displayName === value);
    if (selectedFile) {
      setSelectedFile(selectedFile);
      props.onFileSelect(selectedFile);
      setIsFileSelected(true);
    }
  };

  const onCreatePost = () => {
    if (!selectedFile) return;
    navigate(`/posts/create`, { state: { shapeFile: selectedFile } });
  };

  return (
    <CollapsiblePanel header="2D Files">
      <div className="space-y-4">
        <div className="p-4 border border-gray-300 rounded-lg shadow-md bg-transparent">
          <h3 className="text-md font-semibold mb-2">View 2D Files</h3>
          {isLoading && <p>Loading...</p>}
          {!isLoading && shapeFiles.length > 0 && (
            <Dropdown
              label="Choose a file to view"
              options={shapeFiles.map((file) => file.displayName)}
              onChange={onFileSelect}
            />
          )}
          {!isLoading && shapeFiles.length === 0 && <p>No files found</p>}
          {isFileSelected && (
            <div className="flex justify-end space-x-2 mt-4">
              <button
                onClick={onCreatePost}
                className="bg-[#2fe9ff] text-white px-4 py-2 rounded-lg hover:bg-[#2fe9ff]-600 flex items-center justify-center"
              >
                Create Post
              </button>
            </div>
          )}
        </div>

        <div className="p-4 border border-gray-300 rounded-lg shadow-md bg-transparent">
          <h3 className="text-md font-semibold mb-2">Import 2D Files</h3>
          <FileUploader
            onChange={props.onFileUpload}
            isUploading={props.isUploading}
          />
        </div>
      </div>
    </CollapsiblePanel>
  );
};
